import services from 'services';

/**
 * Fetches all users
 * @param {Function} withLoader - Loading wrapper function
 * @param {Function} errorMessage - Error message handler
 * @param {boolean} includeDeleted - Include deleted users
 * @returns {Promise<Array>} Array of user objects or empty array on error
 */
export const fetchAllUsers = async (withLoader, errorMessage, includeDeleted = false) => {
  try {
    const response = await withLoader(services.getUsers(includeDeleted));
    if (response.success) {
      return response.data.data.map(u => u.data);
    } else {
      const message = response?.response?.data?.data?.message || 'Failed to load users';
      errorMessage(message);
      return [];
    }
  } catch (error) {
    errorMessage('Failed to load users');
    return [];
  }
};

/**
 * Fetches all roles
 * @param {Function} withLoader - Loading wrapper function
 * @param {Function} errorMessage - Error message handler
 * @returns {Promise<Array>} Array of role objects or empty array on error
 */
export const fetchAllRoles = async (withLoader, errorMessage) => {
  try {
    const response = await withLoader(services.getRoles());
    if (response.success) {
      return response.data.data.map(r => r.data);
    } else {
      const message = response?.response?.data?.data?.message || 'Failed to load roles';
      errorMessage(message);
      return [];
    }
  } catch (error) {
    errorMessage('Failed to load roles');
    return [];
  }
};

/**
 * Fetches users for a specific role
 * @param {string} roleId - ID of the role
 * @param {Function} withLoader - Loading wrapper function
 * @param {Function} errorMessage - Error message handler
 * @returns {Promise<Array>} Array of user IDs or empty array on error
 */
export const fetchRoleUsers = async (roleId, withLoader, errorMessage) => {
  try {
    const response = await withLoader(services.getUsersWithRole(roleId));
    if (response.success) {
      return response.data;
    } else {
      const message = response?.response?.data?.data?.message || 'Failed to load role users';
      errorMessage(message);
      return [];
    }
  } catch (error) {
    errorMessage('Failed to load role users');
    return [];
  }
};

export const getUserLabel = user => `${user.firstName} ${user.lastName} (${user.email ?? user.id})`;
